import { RdStationFeatures } from './RdStationFeatures';
import { IntegrationsFeatures } from '../IntegrationsFeatures';
// Controllers
import { RdStationDeleteModalController } from './RdStationDeleteModal/RdStationDeleteModalController';
// Views
import RdStationDeleteModalView from './RdStationDeleteModal/RdStationDeleteModalView.html';
import './RdStation.scss';
// Constants
import { RDSTATION_ACTIVE, RDSTATION_INSTALLATION_TYPE, RDSTATION_OAUTH_INSTALLATION, RDSTATION_PUBLIC_TOKEN, } from '../IntegrationsController';
const ANALYTICS_OWNER_IDENTITY = 'postmaster@analytics.msging.net';
export class RdStationController {
    static $inject = ['application', 'BlipToastService', 'ConfigurationsService', 'IntegrationsSegmentService', 'IntegrationsService', 'LoadingService', 'ModalService', 'RdStationService', 'SegmentService', 'BLIP_DOMAIN_URL', 'RDSTATION_URL', 'RDSTATION_CLIENT_ID', '$translate', '$window'];
    handleRdStationLogin() { }
    constructor(application, BlipToastService, ConfigurationsService, IntegrationsSegmentService, IntegrationsService, LoadingService, ModalService, RdStationService, SegmentService, BLIP_DOMAIN_URL, RDSTATION_URL, RDSTATION_CLIENT_ID, $translate, $window) {
        'ngInject';
        this.application = application;
        this.BlipToastService = BlipToastService;
        this.ConfigurationsService = ConfigurationsService;
        this.IntegrationsSegmentService = IntegrationsSegmentService;
        this.IntegrationsService = IntegrationsService;
        this.LoadingService = LoadingService;
        this.ModalService = ModalService;
        this.RdStationService = RdStationService;
        this.SegmentService = SegmentService;
        this.BLIP_DOMAIN_URL = BLIP_DOMAIN_URL;
        this.RDSTATION_URL = RDSTATION_URL;
        this.RDSTATION_CLIENT_ID = RDSTATION_CLIENT_ID;
        this.$translate = $translate;
        this.$window = $window;
        this.handleRdStationLogin = this.onRdStationLogin.bind(this);
        this.init();
    }
    async init() {
        this.LoadingService.startLoading();
        this.settings = {};
        this.IntegrationsSegmentService.setApplication(this.application);
        await this.checkFeatures();
        await this.fetchConfiguration();
        if (this.isActive && this.installationType == RDSTATION_OAUTH_INSTALLATION) {
            await this.getAccountName();
        }
        this.IntegrationsSegmentService.trackConnectionRdstationOpened();
        this.LoadingService.stopLoading();
    }
    async checkFeatures() {
        this.rdStationOAuthEnabled = await RdStationFeatures.rdStationOAuthEnabled();
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await IntegrationsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await IntegrationsFeatures.isConfigurationsDomainOnChannelsOperationsSetEnabled();
    }
    async fetchConfiguration() {
        try {
            this.settings = await this.ConfigurationsService.get(ANALYTICS_OWNER_IDENTITY, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            this.isActive = this.settings[RDSTATION_ACTIVE].toLowerCase() == 'true' ? true : false;
            this.hasLegacyToken = this.settings[RDSTATION_PUBLIC_TOKEN] ? true : false;
            this.installationType = this.settings[RDSTATION_INSTALLATION_TYPE];
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.oldSettings = { ...this.settings };
        }
    }
    openLoginPopup() {
        const baseUrl = this.RDSTATION_URL;
        const clientId = this.RDSTATION_CLIENT_ID;
        const redirectUrl = `${this.BLIP_DOMAIN_URL.replace(/\/\s*$/, '')}/rdStationCallback`;
        const url = `${baseUrl}?client_id=${clientId}&redirect_url=${redirectUrl}`;
        this.$window.open(url, 'Login With RdStation', 'height=700,width=1000,location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes');
        // Add a message listener to handle popup messages
        this.$window.addEventListener('message', this.handleRdStationLogin);
    }
    async openDisableModal() {
        try {
            const { name, shortName } = this.application;
            await this.ModalService.showModal({
                template: RdStationDeleteModalView,
                controller: RdStationDeleteModalController,
                controllerAs: '$ctrl',
                inputs: {
                    configurations: { name, shortName },
                    onDelete: this.disableIntegration.bind(this),
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async onRdStationLogin(messageEvent) {
        const { code } = messageEvent.data;
        // Check if message is from popup
        if (code) {
            this.LoadingService.startLoading();
            messageEvent.source.close(); // Close popup
            this.$window.removeEventListener('message', this.handleRdStationLogin); // Remove popup listener
            try {
                await this.RdStationService.createToken(code);
                await this.getAccountName();
                await this.removeLegacyToken();
                await this.fetchConfiguration();
                if (this.isActive) {
                    this.IntegrationsSegmentService.
                        trackConnectionRdStationConfigurationInstallClicked(undefined, true);
                    this.BlipToastService.show('success', {
                        title: await this.$translate('rdstation.successMsg.install.title'),
                        msg: await this.$translate('rdstation.successMsg.install.msg'),
                    });
                }
            }
            catch (e) {
                this.IntegrationsSegmentService.
                    trackConnectionRdStationConfigurationInstallClicked(undefined, false);
                this.BlipToastService.show('danger', {
                    title: await this.$translate('rdstation.errorMsg.title'),
                    msg: await this.$translate('rdstation.errorMsg.install'),
                });
            }
            finally {
                this.LoadingService.stopLoading();
            }
        }
    }
    async disableIntegration() {
        try {
            this.LoadingService.startLoading();
            await this.RdStationService.revokeToken();
            await this.fetchConfiguration();
            this.IntegrationsSegmentService.
                trackConnectionRdStationConfigurationUninstallClicked(undefined, true);
            this.BlipToastService.show('success', {
                title: await this.$translate('rdstation.successMsg.uninstall.title'),
                msg: await this.$translate('rdstation.successMsg.uninstall.msg'),
            });
        }
        catch (error) {
            this.IntegrationsSegmentService.
                trackConnectionRdStationConfigurationUninstallClicked(undefined, false);
            this.BlipToastService.show('danger', {
                title: await this.$translate('rdstation.errorMsg.title'),
                msg: await this.$translate('rdstation.errorMsg.uninstall'),
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    /**
     * @deprecated Must be removed when rd-station-o-auth feature toggle is removed
     */
    async onToggle(value) {
        this.isActive = value;
        this.LoadingService.startLoading();
        try {
            this.settings[RDSTATION_ACTIVE] = this.isActive;
            await this.ConfigurationsService.set(ANALYTICS_OWNER_IDENTITY, this.settings, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            if (this.isActive) {
                this.SegmentService.createTrack('integrate-chatbot', {
                    botName: this.application.name,
                    template: this.application.template,
                    integration: 'RDStation',
                });
            }
        }
        catch (e) {
            const errorMsg8 = await this.$translate('utils.errorMsg.10');
            this.BlipToastService.show('danger', {
                msg: errorMsg8,
            });
            this.isActive = !this.isActive;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    /**
     * @deprecated Must be removed when rd-station-o-auth feature toggle is removed
     */
    async save() {
        try {
            this.LoadingService.startLoading();
            await this.ConfigurationsService.set(ANALYTICS_OWNER_IDENTITY, this.settings, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
            this.afterSave();
            this.BlipToastService.show('success', {
                msg: await this.$translate('utils.successMsg.8'),
            });
        }
        catch (err) {
            const errorMsg8 = await this.$translate('utils.errorMsg.10');
            this.BlipToastService.show('danger', {
                msg: errorMsg8,
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async getAccountName() {
        try {
            const { name } = (await this.RdStationService.getAccountDetails()).resource;
            this.rdStationAccountName = name;
        }
        catch (e) {
            this.BlipToastService.show('warning', {
                title: await this.$translate('rdstation.warningMsg.account.title'),
                msg: await this.$translate('rdstation.warningMsg.account.msg'),
            });
        }
    }
    async removeLegacyToken() {
        try {
            await this.ConfigurationsService.deleteSingle(ANALYTICS_OWNER_IDENTITY, RDSTATION_PUBLIC_TOKEN, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * @deprecated Must be removed when rd-station-o-auth feature toggle is removed
     */
    afterSave() {
        if (this.isTokenNew()) {
            this.trackConnectionRdstationConfigurationAddSaved();
        }
        else {
            this.trackConnectionRdstationConfigurationChangesSaved(this.IntegrationsService.objectsDifferentKeys(this.settings, this.oldSettings));
        }
        this.oldSettings = { ...this.settings };
    }
    /**
     * @deprecated Must be removed when rd-station-o-auth feature toggle is removed
     */
    isTokenNew() {
        return this.settings['RdStation.PublicToken'] &&
            this.oldSettings['RdStation.PublicToken'] === undefined;
    }
    // Segment
    /**
     * @deprecated Must be removed when rd-station-o-auth feature toggle is removed
     */
    trackConnectionRdstationConfigurationAddSaved() {
        this.IntegrationsSegmentService
            .trackConnectionRdstationConfigurationAddSaved({
            PublicToken: this.settings['RdStation.PublicToken'],
        });
    }
    /**
     * @deprecated Must be removed when rd-station-o-auth feature toggle is removed
     */
    trackConnectionRdstationConfigurationChangesSaved(changedFields) {
        this.IntegrationsSegmentService
            .trackConnectionRdstationConfigurationChangesSaved({
            ChangedFields: changedFields,
        });
    }
}
RdStationController.$inject = ['application', 'BlipToastService', 'ConfigurationsService', 'IntegrationsSegmentService', 'IntegrationsService', 'LoadingService', 'ModalService', 'RdStationService', 'SegmentService', 'BLIP_DOMAIN_URL', 'RDSTATION_URL', 'RDSTATION_CLIENT_ID', '$translate', '$window'];
